// extracted by mini-css-extract-plugin
export default {"enter":"error-anim__enter___VE9gO","enterActive":"error-anim__enterActive___Z7NQ8","exit":"error-anim__exit___EXrcl","exitActive":"error-anim__exitActive___TpB71"};